import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import * as vo from 'src/app/core/model/server/vo/_index';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({ providedIn: 'root' })
export class FeatTiersService {

  constructor(
    private api: ApiService,
    private authService: AuthService,
  ) {}

  // ─── Tier Features ────────────────────────────────────────────────────────
  getTierFeatures(): Observable<{ rows: vo.TierFeaturesResult[]; totalItems: number }> {
    return this.api.getAllTierFeatures().pipe(
      map((res: vo.GetAllTierFeaturesResponse) => {
        const rows: vo.TierFeaturesResult[] = res.result
          ? (Array.isArray(res.result) ? res.result : [res.result])
          : [];
        return { rows, totalItems: rows.length };
      })
    );
  }

  /**
   * Creates a new tier feature.
   */
  createTierFeature(request: vo.CreateTierFeatureRequest): Observable<vo.BaseResponse> {
    return this.api.createTierFeatures(request);
  }

  /**
   * Updates an existing tier feature.
   */
  updateTierFeature(request: vo.UpdateTierFeatureRequest): Observable<vo.BaseResponse> {
    return this.api.updateTierFeatures(request);
  }

  // ─── Account Tiers (used as dropdown options) ─────────────────────────────

  /**
   * Fetches all account tiers for populating the allowed/denied tier selectors.
   */
  getAccountTiers(): Observable<vo.AccountTiersResponse> {
    return this.api.getAccountsTiers();
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────

  /**
   * Returns a human-readable status label.
   */
  getStatusLabel(status: number): string {
    return status === 0 ? 'Enabled' : 'Disabled';
  }

  /**
   * Returns whether the given status value means "enabled".
   */
  isEnabled(status: number): boolean {
    return status === 0;
  }

  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  get currentUserUid(): number {
    return this.authService.getUserUID();
  }
}
